import axios from 'axios';

// Ensure this matches your backend API base URL
export const API_BASE_URL = 'https://1fiveglobal.in/api/';

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

// ==========================================
// 1. AXIOS REQUEST INTERCEPTOR
// ==========================================
// Automatically attaches the Bearer token to EVERY outgoing request if it exists in localStorage
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ==========================================
// 2. GENERIC REQUEST HANDLER
// ==========================================
// Merges custom options (headers, params, etc.) cleanly into Axios configuration
const request = async (method, url, data = null, options = {}) => {
  try {
    const response = await apiService({
      method,
      url,
      data,
      ...options,
      headers: {
        ...options.headers, // Merges custom headers (e.g. multipart/form-data) with existing config
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ==========================================
// 3. EXPORTED HTTP METHODS
// ==========================================
export const get = (url, options = {}) => request('get', url, null, options);

export const post = (url, data, options = {}) => request('post', url, data, options);

export const put = (url, data, options = {}) => request('put', url, data, options);

export const del = (url, options = {}) => request('delete', url, null, options);

export default apiService;